import type { Channel } from '@sbc/domain-models/gateway';

import { parseChannels } from './inbox-search';

const KEY_PREFIX = 'sbc.inbox.channels.';

type ChannelStore = Pick<Storage, 'getItem' | 'setItem'>;

function browserStore(): ChannelStore | undefined {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
}

export function readInboxChannels(
  viewerId: string,
  store: ChannelStore | undefined = browserStore(),
): Channel[] | undefined {
  try {
    const stored = store?.getItem(KEY_PREFIX + viewerId);
    return stored ? parseChannels(JSON.parse(stored)) : undefined;
  } catch {
    return undefined;
  }
}

export function saveInboxChannels(
  viewerId: string,
  channels: readonly Channel[],
  store: ChannelStore | undefined = browserStore(),
): void {
  try {
    store?.setItem(KEY_PREFIX + viewerId, JSON.stringify(channels));
  } catch {}
}
